import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Table, Button, Badge, Form, Spinner } from "react-bootstrap";
import { DollarSign, Download, RefreshCw, Users, AlertTriangle } from "react-feather";
import * as XLSX from "xlsx";

function PartyOutstandingReport() {
  const [data, setData] = useState([
    { id: 1, PartyName: "Shree Shyam Oil Mill", Station: "Indore", Role: "Supplier", TotalBilled: 15400000, TotalPaid: 12000000, Outstanding: 3400000, Days0_15: 1400000, Days16_30: 2000000, Days31_60: 0, DaysOver60: 0 },
    { id: 2, PartyName: "Pawan Agro Trading Co", Station: "Kandla", Role: "Customer", TotalBilled: 8200000, TotalPaid: 6500000, Outstanding: 1700000, Days0_15: 700000, Days16_30: 500000, Days31_60: 500000, DaysOver60: 0 },
    { id: 3, PartyName: "Mahalaxmi Solvent Ltd", Station: "Nagpur", Role: "Supplier", TotalBilled: 22000000, TotalPaid: 19500000, Outstanding: 2500000, Days0_15: 0, Days16_30: 1000000, Days31_60: 1500000, DaysOver60: 0 },
    { id: 4, PartyName: "Balaji Feeds & Proteins", Station: "Hyderabad", Role: "Customer", TotalBilled: 4500000, TotalPaid: 3200000, Outstanding: 1300000, Days0_15: 300000, Days16_30: 400000, Days31_60: 300000, DaysOver60: 300000 },
  ]);

  const [roleFilter, setRoleFilter] = useState("all");

  const filteredData = data.filter(r => {
    if (roleFilter === "supplier") return r.Role === "Supplier";
    if (roleFilter === "customer") return r.Role === "Customer";
    return true;
  });

  const totalOutstanding = filteredData.reduce((acc, r) => acc + r.Outstanding, 0);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PartyOutstanding");
    XLSX.writeFile(wb, `Party_Outstanding_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  return (
    <div className="page-content" style={{ padding: "15px" }}>
      <Container fluid>
        <Row className="mb-2 align-items-center">
          <Col xs={12} md={6}>
            <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
              <DollarSign className="me-2 text-primary" size={22} />
              Party Outstanding & Aging Analysis (पार्टी उधारी व एजिंग रिपोर्ट)
            </h5>
            <small className="text-muted">Track receivables from customers and payables to suppliers with aging buckets</small>
          </Col>
          <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0 d-flex justify-content-md-end gap-2">
            <Form.Select size="sm" value={roleFilter} onChange={e => setRoleFilter(e.target.value)} style={{ width: "160px" }}>
              <option value="all">All Counterparties</option>
              <option value="supplier">Suppliers (देय राशि / Payables)</option>
              <option value="customer">Customers (प्राप्य राशि / Receivables)</option>
            </Form.Select>
            <Button size="sm" variant="success" onClick={exportToExcel}>
              <Download size={14} className="me-1" /> Excel
            </Button>
          </Col>
        </Row>

        <Card className="shadow-sm border-0">
          <Card.Body className="p-0">
            <Table responsive hover striped bordered className="mb-0 text-center align-middle" style={{ fontSize: "0.85rem" }}>
              <thead className="table-dark">
                <tr>
                  <th>Party Name</th>
                  <th>Station</th>
                  <th>Category</th>
                  <th>Total Deal Value (₹)</th>
                  <th>Settled / Paid (₹)</th>
                  <th className="table-warning text-dark fw-bold">Outstanding Balance (₹)</th>
                  <th>0-15 Days</th>
                  <th>16-30 Days</th>
                  <th>31-60 Days</th>
                  <th className="table-danger text-dark">&gt; 60 Days</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.id}>
                    <td className="text-start ps-3 fw-bold">{row.PartyName}</td>
                    <td>{row.Station}</td>
                    <td>
                      <Badge bg={row.Role === "Supplier" ? "secondary" : "info"} text={row.Role === "Customer" ? "dark" : "white"}>
                        {row.Role === "Supplier" ? "SUPPLIER (विक्रेता)" : "CUSTOMER (क्रेता)"}
                      </Badge>
                    </td>
                    <td>₹ {row.TotalBilled.toLocaleString("en-IN")}</td>
                    <td>₹ {row.TotalPaid.toLocaleString("en-IN")}</td>
                    <td className="table-warning fw-bold text-danger">₹ {row.Outstanding.toLocaleString("en-IN")}</td>
                    <td>₹ {row.Days0_15.toLocaleString("en-IN")}</td>
                    <td>₹ {row.Days16_30.toLocaleString("en-IN")}</td>
                    <td>₹ {row.Days31_60.toLocaleString("en-IN")}</td>
                    <td className="table-danger fw-bold text-danger">₹ {row.DaysOver60.toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light fw-bold">
                <tr>
                  <td colSpan={5} className="text-end pe-3">Total Outstanding:</td>
                  <td className="table-warning text-danger fs-6">₹ {totalOutstanding.toLocaleString("en-IN")}</td>
                  <td colSpan={4}></td>
                </tr>
              </tfoot>
            </Table>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default PartyOutstandingReport;
